import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Typography } from '@material-ui/core';

/* Campo de texto multilinha padrão */
const FormTextArea = ({
    disabled,
    error,
    fullWidth,
    id,
    label,
    maxLength,
    minHeight,
    name,
    onChange,
    readOnly,
    resize,
    style,
    value
}) => {
    const hasError = !!error;

    return (
        <FormGroup>
            {label && (
                <Typography
                    component="p"
                    variant="body2"
                    color={hasError ? 'error' : 'textSecondary'}
                    style={{ marginBottom: 4 }}
                >
                    {label}
                </Typography>
            )}

            <textarea
                id={id || name}
                name={name}
                value={value || ''}
                onChange={onChange}
                disabled={disabled}
                readOnly={readOnly}
                maxLength={maxLength}
                style={{
                    width: fullWidth ? '100%' : undefined,
                    minHeight,
                    padding: 8,
                    boxSizing: 'border-box',
                    border: hasError ? '1px solid #f44336' : '1px solid #cccccc',
                    borderRadius: 4,
                    fontFamily: 'Calibri, sans-serif',
                    outline: 'none',
                    resize,
                    backgroundColor: disabled ? '#f2f2f2' : undefined,
                    cursor: readOnly ? 'default' : undefined,
                    ...style
                }}
            />

            {hasError && (
                <Typography
                    variant="caption"
                    style={{
                        color: '#f44336',
                        marginTop: 4,
                        marginLeft: 2
                    }}
                >
                    {error}
                </Typography>
            )}
        </FormGroup>
    );
};

FormTextArea.propTypes = {
    disabled: PropTypes.bool,
    error: PropTypes.string,
    fullWidth: PropTypes.bool,
    id: PropTypes.string,
    label: PropTypes.string,
    maxLength: PropTypes.number,
    minHeight: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    readOnly: PropTypes.bool,
    resize: PropTypes.oneOf([
        'none',
        'both',
        'horizontal',
        'vertical'
    ]),
    style: PropTypes.object,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ])
};

FormTextArea.defaultProps = {
    disabled: false,
    error: '',
    fullWidth: true,
    id: '',
    label: '',
    maxLength: undefined,
    minHeight: 100,
    onChange: undefined,
    readOnly: false,
    resize: 'vertical',
    style: {},
    value: ''
};

export default FormTextArea;